import Skeleton from '@mui/material/Skeleton'
import React from 'react'
import Carousel from '../Carousel/Carousel'

const cards = Array.from({ length: 8 }, (_, i) => i)

export const LoadingCard = () => {
  return (
    <div className="location-search-card max-w-[270px] min-w-[270px] rounded-2xl bg-white-500 shadow-lg sm:max-w-[300px] sm:min-w-[300px] md:max-w-[280px] md:min-w-[280px]">
      <div className="relative aspect-[130/65] w-full overflow-hidden rounded-t-2xl sm:aspect-[130/70] md:aspect-[160/80]">
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </div>
      <div className="flex flex-col gap-1.5 p-2 sm:gap-1.5 sm:p-2.5 md:gap-1 md:p-2.5">
        <div className="flex items-start justify-between">
          <div className="flex flex-col gap-0.5">
            <div className="flex items-center gap-1">
              <Skeleton
                width={80}
                height={24}
                className="sm:h-[24px] sm:w-[90px] md:h-[24px] md:w-[90px]"
              />
              <Skeleton
                variant="circular"
                width={16}
                height={16}
                className="sm:size-4 md:size-4"
              />
            </div>
            <Skeleton
              width={120}
              height={16}
              className="sm:h-[16px] sm:w-[130px] md:h-[16px] md:w-[130px]"
            />
          </div>
          <Skeleton
            width={60}
            height={20}
            className="rounded-lg sm:h-[24px] sm:w-[65px] md:h-[24px] md:w-[65px]"
          />
        </div>

        <div className="flex items-center gap-1.5 sm:gap-1.5 md:gap-1.5">
          <Skeleton
            variant="circular"
            width={14}
            height={14}
            className="sm:size-3.5 md:size-3.5"
          />
          <Skeleton
            width={30}
            height={16}
            className="sm:h-[16px] sm:w-[35px] md:h-[16px] md:w-[35px]"
          />
          <Skeleton
            width={8}
            height={16}
            className="sm:h-[16px] sm:w-[8px] md:h-[16px] md:w-[8px]"
          />
          <Skeleton
            width={80}
            height={16}
            className="sm:h-[16px] sm:w-[90px] md:h-[16px] md:w-[90px]"
          />
        </div>

        <div className="flex items-end justify-between">
          <div className="flex items-center gap-1.5 sm:gap-1.5 md:gap-1.5">
            <Skeleton
              width={80}
              height={28}
              className="sm:h-[28px] sm:w-[90px] md:h-[28px] md:w-[90px]"
            />
            <Skeleton
              width={50}
              height={24}
              className="rounded-full sm:h-[28px] sm:w-[55px] md:h-[28px] md:w-[55px]"
            />
          </div>
          <Skeleton
            width={60}
            height={24}
            className="rounded-lg sm:h-[28px] sm:w-[65px] md:h-[28px] md:w-[65px]"
          />
        </div>
      </div>
    </div>
  )
}

function LoadingRecommendedCard() {
  return (
    <div className="relative overflow-hidden md:[mask-image:_linear-gradient(to_right,_transparent_0,_white_64px,white_calc(100%-64px),_transparent_100%)]">
      <Carousel
        carouselOptions={{
          loop: true,
          containScroll: false,
          dragFree: true
        }}
        carouselOptionsDesktop={{ align: 'start' }}
        items={cards}
        showButtons
        marginButtons={4}
      >
        {({ item }) => (
          <div key={item} className="pb-4">
            <LoadingCard />
          </div>
        )}
      </Carousel>
    </div>
  )
}

export default React.memo(LoadingRecommendedCard)
